module.exports = __webpack_public_path__ + "static/media/ic_play_2.481a6022.svg";